export type PersonenstandEnum = '001' | '002' | '003' | '004' | '005' | '006 ' | '007' |'008';

export const PersonenstandEnum = {
  _001: '001' as PersonenstandEnum,
    _002: '002' as PersonenstandEnum,
    _003: '003' as PersonenstandEnum,
    _004: '004' as PersonenstandEnum,
    _005: '005' as PersonenstandEnum,
  _006: '006' as PersonenstandEnum,
  _007: '007' as PersonenstandEnum,
  _008: '008' as PersonenstandEnum,
};

